export enum appFeatures {

   Create_Shelf = "CRTFLD",
   Create_Elesson = "CRTLS",
   Create_Book = "CRTBK",
   Create_Mindmap = "CRTMM",
   Access_Connect = "ACCSCONT",
   Banner1 = "b1",
   Copy = "COPY",
   Call_on_Book = "CALLONBK",
   Drawing = "DRAW",
   Create_Ele_Tabs = "ELECRTTAB",
   ELE_Drawing = "ELEDRAW",
   Contact = "CNOTS",
   Access_activity = "ACCSACT",
   Import = "IMPT",
   OutBox = "OUTXOX",
   Inbox = "INXB",
   Cloud = "CLOUD",
   Chats = "CHAT",
   Access_Recourse = "ACCSRCS",
   Save_as_PDF = "SVEPDF",
   Print_created_Book = "PRTCBK",
   Contact_to_Export = "CNTEXPT",
   publish_Online = "PUBONLN",
   Publish_to_Public = "PUBPLK",
   Share = "SHRE",
   Book_mark = "BKMRK",
   Malzamah_as_Copy = "MLZCPY",
   Save_Tabs_as_Lesson = "SAVTBSLSS",
   Duplicate_as_Page = "CRTDUBPG",
   Create_Pdf_Tabs = "CRTTAB",
   EXPORT = "EXPORT",
   Book_Search = "BKSRCH",
   Public_Book_Inbox = "PUBBKINBX",
   Lesson_Mark = "ELELESSONMARK",
   Call_on_Lesson = "CALLONLESS",
   ELE_Save_tabs_as_lesson = "ELESAVTABSASLESSON",
   ELE_Malzamah_as_Copy = "ELEMLZASCPY",
   Elesson_multilevel_tabs = "ELEMIULTILEVL",
   ELE_EXPORT = "ELEEXPORT",
   Lesson_Search = "ELESRCH",
   Feedback = "ELEFEEDBACK",
   Statistics = "ELESTATICS",
   Print = "ELEPRINT",
   Save_as_Template = "ELESAVASTPL", 
   COPY = "COPY",	
   Call_On_Book = "CALLONBK",	
   Duplicate_as_Image = "CRTDLBIMG",	
   Save_Page_as_Template = "SAVPGTPL",
   Malzamah_as_Link = "MLZLINK",
   Annotate = "ANNOTATE",
   pdf_Print = "PRINT",
   Online_Enrichments = "ONLINENCH",
   Multi_Level_Tabs = "MULTILVLTAB",
   Show_Recent="SHWRCT",
   Create_Book_Template="CRTBKTM",
   Create_Album="CRTALM",
   Create_Web_book="CRTWBK",
   Create_activity="CRTACT",
   Calls="CALL",
   News_Board="NWSBRD",
   Shelf_Search="SHFSRCH",
   SYNC="SYNC",
   Backup_Restore="BKUP",
   Publish_to_store="PUBSTR",
   Export_to_Social_Network="EXPTSCIL",
   Notes = "ELENOTE",
   Duplicate_as_image = "ELEDUBASIMG",
   Malzamah_as_link = "ELEMLZASLINK",
   name =  "code",

  
}


// WEBPACK FOOTER //
// ./src/app/shared/models/appFeatures.ts